<h2 mat-dialog-title>Texture settings</h2>
<mat-dialog-content>
    <form id="textureForm" (submit)="confirmAction()">
        <mat-form-field>
            <input
                [ngModel]="$result().displacement"
                (ngModelChange)="$result.set({...$result(), displacement: $event})"
                matInput
                type="number"
                [placeholder]="!$imperial() ? 'Displacement (cm)' : 'Displacement (in)'"
                name="textureDisplacement"
            />
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelAction()">Cancel</button>
    <button mat-button form="textureForm" [disabled]="$result().displacement === undefined">Ok</button>
</mat-dialog-actions>
